import * as angular from "angular";

export class IssueService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/query";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot);
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/info/" + data.id, data);
    }

    filter(params: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/filter", { params: params });
    }

    statuses(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/statuses", data);
    }

    origins(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/origins", data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/create", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/update/" + data.id, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/delete/" + data.id, data);
    }

    bulk_delete(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_delete", data);
    }

    bulk_priority(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_priority", data);
    }

    bulk_assign(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_assign", data);
    }

    bulk_status(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_status", data);
    }

    bulk_group(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_group", data);
    }

    addMembersFromFilter(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/addMembersFromFilter", data);
    }
}

angular.module("vcServices").service("IssueService", IssueService);
